import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

import { color } from '@/theme';
import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { PrimaryButton } from '@/components/button';
import { CommonDescOne, CommonTitleOne } from '@/components/text/CommonTexts';
import { BoldText, MediumText, RegularText } from '@/components/text';

const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8rem 0',
  padding: '8rem 1.6rem',
  textAlign: 'center',
}));

const ButtonWrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  maxWidth: '80rem',
  width: '100%',
}));
const FormCompleteScreen = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const lang = localStorage.getItem(LOCAL_LANGUAGE) || 'en';

  const goToWebsite = useCallback(() => {
    window.open(`https://www.inspireresorts.com/${lang}`, '_blank', 'noopener, noreferrer');
  }, [lang]);

  const goToMain = useCallback(() => {
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    if (!state?.complete) {
      navigate('/not-found');
    }
  }, [navigate, state?.complete]);

  return (
    <Container>
      <CommonTitleOne>
        <BoldText id="lang-submit-success-message" fontSize="inherit" />
      </CommonTitleOne>

      <CommonDescOne>
        {state?.type === 'arena' ? (
          <div>
            <p>
              <RegularText id="lang-arena-success-message-1" fontSize="inherit" />
            </p>
          </div>
        ) : (
          <div>
            <p>
              <RegularText id="lang-event-success-message-1" fontSize="inherit" />
            </p>

            <p>
              <RegularText id="lang-event-success-message-2" fontSize="inherit" />
            </p>

            <p>
              <RegularText id="lang-event-success-message-3" fontSize="inherit" />
            </p>

            <p>
              <RegularText id="lang-event-success-message-4" fontSize="inherit" />
            </p>
          </div>
        )}
      </CommonDescOne>

      <ButtonWrapper>
        <PrimaryButton onClick={goToWebsite} height="7.4rem">
          <MediumText id="lang-visit-website" color={color.base_white} />
        </PrimaryButton>

        <PrimaryButton onClick={goToMain} height="7.4rem">
          <MediumText id="lang-make-another-inquiry" color={color.base_white} />
        </PrimaryButton>
      </ButtonWrapper>
    </Container>
  );
};

export default FormCompleteScreen;
